var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 58,
    viewBox: "0 0 350 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.719 54H-0.00106812V9H264.688C289.054 9 312.581 17.8957 330.851 34.0162L344.999 46.5L349.719 54Z",
    fill: "url(#paint0_linear_779_37481)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.968 0H0V13H268.945C302.295 13 331.832 29.3256 350 54.4209C333.426 22.1098 299.779 0 260.968 0Z",
    fill: "url(#paint1_linear_782_37413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_779_37481",
    x1: 235.415,
    y1: 69.6718,
    x2: 235.284,
    y2: -0.942364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "var(--advisor-profile-page-color1)",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--advisor-profile-page-color3)",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_782_37413",
    x1: 362.927,
    y1: 63.6142,
    x2: 5.69556,
    y2: 53.5051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2AB94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "var(--advisor-profile-page-color4)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--advisor-profile-page-main-color)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTop);
export default __webpack_public_path__ + "static/media/other_top.70d187386917c1009bb565031f239280.svg";
export { ForwardRef as ReactComponent };